import React from 'react'
import { useSelector } from 'react-redux'
import { selectCmsDescription } from '../../store/seo/seo.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import TextCssShortener from '../genericComponents/TextCssShortener'
import HTMLTextFromMarkdown from '../ui/HTMLTextFromMarkdown'
import s from './AddressDescription.less'

const AddressDescription = () => {
  const cmsDescription = useSelector(selectCmsDescription)

  if (!cmsDescription) return <></>

  return (
    <TextCssShortener className={s.description}>
      <HTMLTextFromMarkdown htmlText={cmsDescription} />
    </TextCssShortener>
  )
}

export default withEmptyFallbackErrorBoundary(AddressDescription)
